import { useIntl } from "react-intl";

import { ExpandableSection } from "@/components/ExpandableSection/ExpandableSection";
import type { HotelData } from "@/features/hotels/types/types";

type HotelAboutCardProps = {
  hotel: HotelData;
};

export const HotelAboutCard = ({ hotel }: HotelAboutCardProps) => {
  const intl = useIntl();

  const description = hotel.descriptions?.full || hotel.descriptions?.short;

  if (!description) {
    return null;
  }

  return (
    <div className="section-card">
      <p className="mb-3 text-lg font-semibold text-text-primary">
        {intl.formatMessage({
          defaultMessage: "About Hotel",
          description: "Section heading for the hotel description",
        })}
      </p>
      <ExpandableSection
        openLabel={intl.formatMessage({
          defaultMessage: "Read more",
          description: "Expand hotel description toggle",
        })}
        closeLabel={intl.formatMessage({
          defaultMessage: "Read less",
          description: "Collapse hotel description toggle",
        })}
      >
        <div className="text-sm text-text-primary">{description}</div>
      </ExpandableSection>
    </div>
  );
};
